{
  "CA": "Canada",
  "US": "États-Unis",
  "CA_AB": "Alberta",
  "CA_BC": "Colombie-Britannique",
  "CA_MB": "Manitoba",
  "CA_NB": "Nouveau-Brunswick",
  "CA_NL": "Terre-Neuve-et-Labrador",
  "CA_NS": "Nouvelle-Écosse",
  "CA_NT": "Territoires du Nord-Ouest",
  "CA_NU": "Nunavut",
  "CA_ON": "Ontario",
  "CA_PE": "Île-du-Prince-Édouard",
  "CA_QC": "Québec",
  "CA_SK": "Saskatchewan",
  "CA_YT": "Yukon",
  "US_AK": "Alaska",
  "US_AL": "Alabama",
  "US_AR": "Arkansas",
  "US_AS": "Samoa américaines",
  "US_AZ": "Arizona",
  "US_CA": "Californie",
  "US_CO": "Colorado",
  "US_CT": "Connecticut",
  "US_DC": "District de Columbia",
  "US_DE": "Delaware",
  "US_FL": "Floride",
  "US_GA": "Géorgie",
  "US_GU": "Guam",
  "US_HI": "Hawaï",
  "US_IA": "Iowa",
  "US_ID": "Idaho",
  "US_IL": "Illinois",
  "US_IN": "Indiana",
  "US_KS": "Kansas",
  "US_KY": "Kentucky",
  "US_LA": "Louisiane",
  "US_MA": "Massachusetts",
  "US_MD": "Maryland",
  "US_ME": "Maine",
  "US_MI": "Michigan",
  "US_MN": "Minnesota",
  "US_MO": "Missouri",
  "US_MP": "Îles Mariannes du Nord",
  "US_MS": "Mississippi",
  "US_MT": "Montana",
  "US_NC": "Caroline du Nord",
  "US_ND": "Dakota du Nord",
  "US_NE": "Nebraska",
  "US_NH": "New Hampshire",
  "US_NJ": "New Jersey",
  "US_NM": "Nouveau-Mexique",
  "US_NV": "Nevada",
  "US_NY": "New York",
  "US_OH": "Ohio",
  "US_OK": "Oklahoma",
  "US_OR": "Oregon",
  "US_PA": "Pennsylvanie",
  "US_PR": "Porto Rico",
  "US_RI": "Rhode Island",
  "US_SC": "Caroline du Sud",
  "US_SD": "Dakota du Sud",
  "US_TN": "Tennessee",
  "US_TX": "Texas",
  "US_UM": "Îles mineures éloignées des États-Unis",
  "US_UT": "Utah",
  "US_VA": "Virginie",
  "US_VI": "Îles Vierges",
  "US_VT": "Vermont",
  "US_WA": "Washington",
  "US_WI": "Wisconsin",
  "US_WV": "Virginie-Occidentale",
  "US_WY": "Wyoming",
  "GB_ENG": "Angleterre",
  "GB_NIR": "Irlande du Nord",
  "GB_SCT": "Écosse"
}
